import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { Profile } from '../../../../profiles/models/profile';
import { Table } from 'primeng/table';
import * as ProfileTypes from '../../../../profiles/models/profile-types';

@Component({
  selector: 'mojo-profile-table',
  templateUrl: './profile-table.component.html'
})
export class ProfileTableComponent implements OnInit {
  @ViewChild('dt', { static: true }) dt: Table;
  @Input()
  searchText: string;
  @Input()
  profiles: Profile[] = [];
  @Input()
  loading: boolean = false;
  @Output()
  onRowClicked = new EventEmitter<Profile>();
  @Input()
  filterIncludeStandard: boolean = true;
  @Input()
  filterIncludeCustom: boolean = true;

  ngOnInit() {}

  applyFilter() {
    const values = [];

    if (this.filterIncludeStandard) {
      values.push(ProfileTypes.Standard);
    }
    if (this.filterIncludeCustom) {
      values.push(ProfileTypes.Custom);
    }

    this.dt.filter(this.searchText, 'name', 'contains');

    // NB: if neither checkboxes are selected datatable.filter will return all rows, if this is not desired we can add a non matching value
    this.dt.filter(values, 'type', 'in');

  }

  showDialogToAdd() {
  }

  onRowSelect(data: Profile) {
    this.onRowClicked.emit(data);
  }

}
